import React from 'react'

import EncoderListing from './EncoderListing'

const EncoderSelector = (props) => {
  const { event, encoders, assignEncoder, isResolving, actions } = props
  const status = event.eventStatus
  // const disabledEncoderStatus = ['live', 'on break', 'starting', 'disconnected', 'stopping']
  // const encodersDisabled = disabledEncoderStatus.includes(status)
  const enabledEncoderStatus = ['new', 'available']
  const encodersDisabled = !enabledEncoderStatus.includes(status)

//   console.log('status', status, !enabledEncoderStatus.includes(status));
  return (
    <div className='event-encoder-select'>
      <EncoderListing
        event={event}
        encoders={encoders}
        disabled={encodersDisabled}
        assignEncoder={assignEncoder}
        isResolving={isResolving}
        actions={actions}
      />
    </div>
  )
}

export default EncoderSelector